import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import EditCustomer from "./edit"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import closeIcon from "../../../assets/icons/close.svg"
import CustomerFilter from "./filter"
import { updateCustomerStatus } from "../../../services/projectManager/customer"
import { fetchFinanceBankReconciliation } from "../../../services/finance/finance"
import BankReconciliationFilter from "./filter"
import moment from "moment"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"

const BankReconciliation = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Bank Reconciliation${
    companyname ? ` | ${companyname}` : ""
  }`
  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
  })

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const [refresh, setRefresh] = useState(0)
  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [customerType, setCustomerType] = useState("")
  const [voucherChange, setVoucherChange] = useState("")
  const [page, setPage] = useState("")
  const [financial, setFinancial] = useState(true)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleEdit = item => {
    setEditClass({ modal: false, value: item, id: item?.id })
  }
  const handleView = item => {
    setViewData(item)
    toggle()
  }
  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateCustomerStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const { control } = useForm()

  const columns = [
    {
      label: "Date",
      renderCell: item => moment(item?.created_at).format("MM-DD-YYYY"),
    },
    // {
    //   label: "Description",
    //   renderCell: item => item?.ledger?.name,
    // },
    {
      label: "Voucher Type",
      renderCell: item => {
        return <div>{item?.voucher_type}</div>
      },
    },
    {
      label: "Voucher Number",
      renderCell: item => {
        return <div>{item?.voucher_entry?.ref_number}</div>
      },
    },
    {
      label: "Instrument Type",
      renderCell: item => {
        return (
          <div>
            {item?.bank_payments[0]?.payment_type_value?.value
              ? item?.bank_payments[0]?.payment_type_value?.value
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Instrument Number",
      renderCell: item => {
        return (
          <div>
            {item?.bank_payments[0]?.instrument_no
              ? item?.bank_payments[0]?.instrument_no
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Instrument Date",
      renderCell: item => {
        return (
          <div>
            {item?.bank_payments[0]?.instrument_date
              ? moment(item?.bank_payments[0]?.instrument_date).format(
                  "DD-MM-YYYY"
                )
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Bank Date",
      renderCell: item => {
        return (
          <div>
            <UFDate
              control={control}
              // value={item?.created_at ? moment(item.created_at).toDate() : null}
              // onDateChange={date =>
              //   handleRowDateChange(item.id, moment(date).format("YYYY-MM-DD"))
              // }
              placeholder="Select Date"
              name={`update_date_${item.id}`}
              className="form-control"
            />
            {/* {item?.bank_payments[0]?.instrument_date
              ? moment(item?.bank_payments[0]?.instrument_date).format(
                  "DD-MM-YYYY"
                )
              : "-"} */}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Debit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.debit_amount), desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.credit_amount),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await fetchFinanceBankReconciliation({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${
          customerType == "0" || customerType == "1"
            ? `&customer_type=${customerType}`
            : ""
        }${page ? `&page=${page}` : ""}${
          voucherChange ? `&ledger_id=${voucherChange}` : ""
        }${datefrom ? `&start_date=${datefrom}` : ""}${
          dateto ? `&end_date=${dateto}` : ""
        }`,
      })
      // setClassData(response)
      const newData = response?.data?.data || []

      setClassData(prev =>
        page > 1 && prev
          ? {
              ...response,
              data: {
                ...response.data,
                data: [...(prev.data?.data || []), ...newData],
              },
            }
          : response
      )
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
      // ${`&financial=${financial}`}
    }
    if (voucherChange && datefrom && dateto) {
      fetchClass()
    }
  }, [
    refresh,
    status,
    search,
    customerType,
    page,
    financial,
    voucherChange,
    datefrom,
    dateto,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [classData, page])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  const handleCatChange = id => {
    setCustomerType(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  const handleVoucherChange = id => {
    setVoucherChange(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                {
                  title: "Bank Reconciliation",
                  link: "/finance-bank-reconciliation",
                },
              ]}
            />
            {/* <EditCustomer
              key={"x"}
              onUpdate={handleUpdate}
              onReset={handleReset}
              editValue={editClass}
              buttonLabel="+&nbsp; Customer"
              className="px-2 mb-3 btn btn-primary"
            /> */}
          </div>
          <Card className="me-2 px-2 pb-2">
            <BankReconciliationFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCatChange={handleCatChange}
              handleFinacialChange={handleFinacialChange}
              handleVoucherChange={handleVoucherChange}
              handleDateChange={handleDateChange}
              sampleUrl={"download/customer.xlsx"}
              importUrl={"customer/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div
                  ref={tableContainerRef}
                  style={{ maxHeight: "385px", overflowY: "auto" }}
                >
                  {classData ? (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      tableWidth="8%  12% 10% 10% 10% 10% 20% 10% 10%"
                      mobileWidth="30% 30% 30% 30%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <p>Please select a ledger and date.</p>
                    </div>
                  )}
                </div>
              </Col>
              {classData ? (
                <Row className="mt-2">
                  <Col lg={6}></Col>
                  <Col lg={6} className="text-muted">
                    <Row>
                      <Col lg={8}>Balance As per Company Book</Col>
                      <Col lg={4} className="text-end pe-5 fw-bold">
                        {/* {classData?.openingBalance_type == "debit"
                          ?  */}
                        {NumberFormat(
                          Math.abs(
                            Number(
                              classData?.totals?.balance_as_company_books || 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                        {/* : "-"} */}
                      </Col>
                      {/* <Col lg={4} className="text-end pe-5 fw-bold">
                        {classData?.openingBalance_type == "credit"
                          ? NumberFormat(
                              Math.abs(Number(classData?.openingBalance || 0)),
                              desimalrange,
                              desimalrange
                            )
                          : "-"}
                      </Col> */}
                    </Row>
                    <Row className="my-2">
                      <Col lg={8}>Amount Not Reflected in Bank</Col>
                      <Col lg={4} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(
                            Number(
                              classData?.totals
                                ?.amounts_not_reflected_in_bank_credit || 0
                            )
                          ),
                          desimalrange,
                          desimalrange
                        )}
                      </Col>
                      {/* <Col lg={4} className="text-end pe-5 fw-bold">
                        {NumberFormat(
                          Math.abs(Number(classData?.currentCredit || 0)),
                          desimalrange,
                          desimalrange
                        )}
                      </Col> */}
                    </Row>
                    <Row className="fw-bold">
                      <Col lg={8}>Balance as per Bank</Col>
                      <Col lg={4} className="text-end pe-5">
                        {/* {classData?.closingBalance_type == "debit"
                          ?  */}
                        {NumberFormat(
                          Math.abs(
                            Number(classData?.totals?.balance_as_bank || 0)
                          ),
                          desimalrange,
                          desimalrange
                        )}
                        {/* : "-"} */}
                      </Col>
                      {/* <Col lg={4} className="text-end pe-5">
                        {classData?.closingBalance_type == "credit"
                          ? NumberFormat(
                              Math.abs(Number(classData?.closingBalance || 0)),
                              desimalrange,
                              desimalrange
                            )
                          : "-"}
                      </Col> */}
                    </Row>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-4">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Type
              </Col>
              <Col className="primary-text">
                {viewData?.customer_type?.label}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Code
              </Col>
              <Col className="primary-text">{viewData?.customer_code}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Name
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.customer_name}
                </div>
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Email ID
              </Col>
              <Col className="primary-text">{viewData?.email_id}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Person
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person}
                </div>
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Number
              </Col>
              <Col className="primary-text">
                {MobileNumberFormat("+" + viewData?.customer_number)}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Designation
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person_designation}
                </div>
              </Col>
            </Row>
            {viewData?.contact_person_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Person Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_two}
                  </div>
                </Col>
              </Row>
            )}
            {viewData?.customer_number_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Number Two
                </Col>
                <Col className="primary-text">
                  {MobileNumberFormat("+" + viewData?.customer_number_two)}
                </Col>
              </Row>
            )}
            {viewData?.contact_person_designation_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Designation Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_designation_two}
                  </div>
                </Col>
              </Row>
            )}

            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Address
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">{viewData?.address}</div>
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal>
    </React.Fragment>
  )
}

export default BankReconciliation
